import { BGA, DIE } from "../../../../constants/componentType";
import { ModelPin } from "../../../helper/IntegratedInterface";
import { AUTO, INPUT, ONLY_DRIVER_MODEL_TYPES, OUTPUT } from "../../../LibraryHelper";
import { getIbisModelList } from "../../library";

async function updateComponentUsageToPinsUsage({ components, name, usage, currentConfig }) {
  const { configContent } = currentConfig || {};
  const { compliance } = configContent || {};
  const txResValue = compliance && compliance.tx && compliance.tx.R ? compliance.tx.R.value : null;
  const txCapValue = compliance && compliance.tx && compliance.tx.C ? compliance.tx.C.value + "p" : "0.2p";
  const rxResValue = compliance && compliance.rx && compliance.rx.R ? compliance.rx.R.value : null;
  const rxCapValue = compliance && compliance.rx && compliance.rx.C ? compliance.rx.C.value + "p" : "0.2p";
  let _components = components ? JSON.parse(JSON.stringify(components)) : [];
  _components.forEach(comp => {
    if (comp.name === name) {
      comp.usage = usage;
      let model = comp.model, libType = "", libraryId = "", fileName = "";
      if (model && model.files && model.files[0]) {
        libType = model.files[0].type;
        libraryId = model.files[0].libraryId;
        fileName = model.files[0].fileName;
      }
      let modelObj = {};
      comp.pins.forEach(async (pinItem) => {
        pinItem.usage = usage;
        if (!pinItem.model) {
          pinItem.model = {
            libType,
            libraryId,
            fileName,
            modelType: "",
            modelName: "",
            enableVoltage: ""

          }
        }
        const prevModelType = pinItem.model.modelType
        const newUsage = pinItem.usage
        const shouldClear = (prevModelType && ONLY_DRIVER_MODEL_TYPES.includes(prevModelType) && newUsage === 'Receiver')
          || (prevModelType && INPUT.includes(prevModelType) && newUsage === 'Driver')

        if (pinItem.model && pinItem.model.libraryId && shouldClear) {
          pinItem.model = {
            ...pinItem.model,
            modelName: "",
            modelType: "",
            enableVoltage: ""
          }
        }

        if (pinItem.usage === "Receiver") {
          pinItem.pinModels = []
        }

        if (pinItem.usage === "Driver" && (!pinItem.pinModels || !pinItem.pinModels.length)) {
          let deviceVcc = ""

          if (pinItem.model.libType === "IBIS" && pinItem.model.libraryId) {
            const id = pinItem.model.libraryId;
            modelObj[id] = modelObj[id] ? modelObj[id] : await getIbisModelList({ libraryId: id, usage: '' })
            const models = modelObj[id];
            const modelInfo = models ? (models.models || []).find(item => item.name === pinItem.model.modelName) : null;
            deviceVcc = modelInfo && modelInfo.deviceVcc && modelInfo.deviceVcc !== "NA" ? parseFloat(modelInfo.deviceVcc).toString() : "";
            comp.deviceVcc = deviceVcc || "";
          }

          pinItem.pinModels = updateICPinModelsByBuffer({
            pinModels: pinItem.pinModels,
            usage: pinItem.usage,
            libType: pinItem.model.libType,
            modelType: pinItem.model.modelType || "I/O",
            pu: deviceVcc,
            pd: "0"
          })
        }
        let pinCompliance = { R: null, C: null };
        if (comp.usage === 'Driver') {
          pinCompliance = { R: txResValue, C: txCapValue };
        } else if (comp.usage === 'Receiver') {
          pinCompliance = { R: rxResValue, C: rxCapValue };
        }
        if (!pinCompliance.R) {
          delete pinCompliance.R;
        }
        pinItem.compliance = { ...pinCompliance }

        pinItem.powerOff = "";
      })
    }
  })
  return _components;
}

async function updateAllComponentPinsUsage({ pcbId, components, component, usage, signals, compList }) {
  if (!components || !components.length) {
    return components;
  }
  let _components = components ? JSON.parse(JSON.stringify(components)) : [];
  const compIndex = _components.findIndex(item => item.name === component);
  if (compIndex < 0 || !components[compIndex] || !Array.isArray(components[compIndex].pins)) {
    return components;
  }
  let model = _components[compIndex].model, libType = "", libraryId = "", fileName = "";
  if (model && model.files && model.files[0]) {
    libType = model.files[0].type;
    libraryId = model.files[0].libraryId;
    fileName = model.files[0].fileName;
  }

  let modelObj = {};

  for (let pinItem of _components[compIndex].pins) {

    pinItem.usage = usage;
    if (!pinItem.model) {
      pinItem.model = {
        libType,
        libraryId,
        fileName,
        modelType: "",
        modelName: "",
        enableVoltage: ""

      }
    }
    // Delete model or not, stimulus
    const prevModelType = pinItem.model.modelType
    const newUsage = pinItem.usage
    const shouldClear = (prevModelType && ONLY_DRIVER_MODEL_TYPES.includes(prevModelType) && newUsage === 'Receiver')
      || (prevModelType && INPUT.includes(prevModelType) && newUsage === 'Driver')

    if (pinItem.model && pinItem.model.libraryId && shouldClear) {
      pinItem.model = {
        ...pinItem.model,
        modelName: "",
        modelType: "",
        enableVoltage: ""
      }
    }

    if (pinItem.usage === "Receiver") {
      pinItem.pinModels = []
    }

    if (pinItem.usage === "Driver" && (!pinItem.pinModels || !pinItem.pinModels.length)) {
      let deviceVcc = ""

      if (pinItem.model.libType === "IBIS" && pinItem.model.libraryId) {
        const id = pinItem.model.libraryId;
        modelObj[id] = modelObj[id] ? modelObj[id] : await getIbisModelList({ libraryId: id, usage: '' })
        const models = modelObj[id];
        const modelInfo = models ? (models.models || []).find(item => item.name === pinItem.model.modelName) : null;
        deviceVcc = modelInfo && modelInfo.deviceVcc && modelInfo.deviceVcc !== "NA" ? parseFloat(modelInfo.deviceVcc).toString() : "";
        _components[compIndex].deviceVcc = deviceVcc || "";
      }

      pinItem.pinModels = updateICPinModelsByBuffer({
        pinModels: pinItem.pinModels,
        usage: pinItem.usage,
        libType: pinItem.model.libType,
        modelType: pinItem.model.modelType || "I/O",
        pu: deviceVcc,
        pd: "0"
      })
    }

    pinItem.powerOff = "";
    if (usage === "Driver") {
      signals.push(pinItem.signal);
      compList.push(`${pcbId}::${component}`)
    }
  };

  return _components
}

function updateICPinModelsByBuffer({ pinModels, usage, libType, modelType, pu, pd }) {
  if (usage === "Receiver") {
    return []
  }
  if (!pinModels || !pinModels.length) {
    pinModels = getPins({ type: modelType || "I/O", usage: usage });
  }

  if (OUTPUT.includes(modelType) || libType === "SPICE") {
    const findEnableIndex = pinModels ? pinModels.findIndex(item => item.pinName === 'nd_en') : -1;
    if (findEnableIndex > -1) {
      pinModels.splice(findEnableIndex, 1)
    }
  }

  const findPU = pinModels.findIndex(item => item.pinName === 'nd_pu');
  if (findPU > -1) {
    pinModels[findPU].voltage = pu;
  };
  const findPD = pinModels.findIndex(item => item.pinName === 'nd_pd');
  if (findPU > -1) {
    pinModels[findPD].voltage = pd;
  }

  return pinModels;
}

function getPins({ type, usage }) {
  let pins = [];
  const _type = typeof (type) === 'string' ? type.toUpperCase() : type;
  // 
  if (!type || usage === 'Receiver' || _type === 'INPUT') { return pins }
  pins = AUTO;
  // ModelPin
  const modelPins = pins.map(pinName => new ModelPin({ pinName }));
  return modelPins;
}

async function setDefaultUsageByDriver({ content, compList, signals, model, usageOppositeDirApply, usage, group, usageCompGroupApply }) {
  const groupType = group && group.includes("TX") ? "TX" : group && group.includes("RX") ? "RX" : "";
  let _usage = usage === 'Driver' ? 'Receiver' : 'Driver';
  if (!content || !content.Components) {
    return null;
  }
  let _content = JSON.parse(JSON.stringify(content));

  for (let comp of _content.Components) {
    if (![BGA, DIE].includes(comp.type)) {
      continue;
    }
    const isSetDefault = comp.model && comp.model.files && Array.isArray(comp.model.files)
      && comp.model.files[0] &&
      comp.model.files[0].libraryId && comp.model.files[0].fileName && model && comp.model.files[0].libraryId !== model.libraryId ? false : true;
    //apply usage to receiver of same signal 
    comp.pins.forEach(pinItem => {
      if (signals.includes(pinItem.signal)
        && !compList.includes(`${content.designId}::${comp.name}`)) {
        if (usageCompGroupApply && pinItem.group.includes(groupType) && groupType) {
          pinItem.usage = _usage;
        } else if (usageOppositeDirApply && !pinItem.group.includes(group)) {
          pinItem.usage = usage;
        } else {
          pinItem.usage = _usage;
        }

        pinItem.pinModels = [];
        //remove output model
        if (pinItem.model && ONLY_DRIVER_MODEL_TYPES.includes(pinItem.model.modelType)) {
          pinItem.model = {
            ...(pinItem.model || {}),
            modelName: "",
            modelType: "",
            enableVoltage: ""
          }
        }
        //apply default receiver spice model
        if (isSetDefault &&
          (!pinItem.model || !Object.keys(pinItem.model).length || !pinItem.model.modelName
            || (pinItem.model && pinItem.model.modelType && ONLY_DRIVER_MODEL_TYPES.includes(pinItem.model.modelType)))) {
          pinItem.model = JSON.parse(JSON.stringify(model || {}))
          if (model && model.libraryId && (!comp.model || !comp.model.files || !comp.model.files.length || !comp.model.files.find(it => !!it.libraryId))) {
            comp.model = {
              files: [{
                type: "SPICE",
                libraryId: pinItem.model.libraryId,
                component: "",
                fileName: pinItem.model.fileName,
                version: pinItem.model.version
              }]
            }
          }
        }
      }
    })
  }
  return _content;
}

async function updateComponentPinsUsageByGroup({ pcbId, components, component, usage, signals, compList, group }) {
  const groupType = group && group.includes("TX") ? "TX" : group && group.includes("RX") ? "RX" : "";
  if (!components || !components.length) {
    return components;
  }
  let _components = components ? JSON.parse(JSON.stringify(components)) : [];
  const compIndex = _components.findIndex(item => item.name === component);
  if (compIndex < 0 || !components[compIndex] || !Array.isArray(components[compIndex].pins)) {
    return components;
  }
  let model = _components[compIndex].model, libType = "", libraryId = "", fileName = "";
  if (model && model.files && model.files[0]) {
    libType = model.files[0].type;
    libraryId = model.files[0].libraryId;
    fileName = model.files[0].fileName;
  }

  let modelObj = {};

  for (let pinItem of _components[compIndex].pins) {
    if (pinItem.group.includes(groupType) && groupType) {
      pinItem.usage = usage;
      if (!pinItem.model) {
        pinItem.model = {
          libType,
          libraryId,
          fileName,
          modelType: "",
          modelName: "",
          enableVoltage: ""

        }
      }
      // Delete model or not, stimulus
      const prevModelType = pinItem.model.modelType
      const newUsage = pinItem.usage
      const shouldClear = (prevModelType && ONLY_DRIVER_MODEL_TYPES.includes(prevModelType) && newUsage === 'Receiver')
        || (prevModelType && INPUT.includes(prevModelType) && newUsage === 'Driver')

      if (pinItem.model && pinItem.model.libraryId && shouldClear) {
        pinItem.model = {
          ...pinItem.model,
          modelName: "",
          modelType: "",
          enableVoltage: ""
        }
      }

      if (pinItem.usage === "Receiver") {
        pinItem.pinModels = []
      }

      if (pinItem.usage === "Driver" && (!pinItem.pinModels || !pinItem.pinModels.length)) {
        let deviceVcc = ""

        if (pinItem.model.libType === "IBIS" && pinItem.model.libraryId) {
          const id = pinItem.model.libraryId;
          modelObj[id] = modelObj[id] ? modelObj[id] : await getIbisModelList({ libraryId: id, usage: '' })
          const models = modelObj[id];
          const modelInfo = models ? (models.models || []).find(item => item.name === pinItem.model.modelName) : null;
          deviceVcc = modelInfo && modelInfo.deviceVcc && modelInfo.deviceVcc !== "NA" ? parseFloat(modelInfo.deviceVcc).toString() : "";
          _components[compIndex].deviceVcc = deviceVcc || "";
        }

        pinItem.pinModels = updateICPinModelsByBuffer({
          pinModels: pinItem.pinModels,
          usage: pinItem.usage,
          libType: pinItem.model.libType,
          modelType: pinItem.model.modelType || "I/O",
          pu: deviceVcc,
          pd: "0"
        })
      }

      pinItem.powerOff = "";
      signals.push(pinItem.signal);
      compList.push(`${pcbId}::${component}`)
    }
  };

  return _components
}

async function updateComponentPinsUsageOpposite({ pcbId, components, component, usage, signals, compList, group }) {
  let _usage = usage;
  const currentGroup = group && group.includes("TX") ? "TX" : group && group.includes("RX") ? "RX" : "";
  const groupType = group && group.includes("TX") ? "RX" : group && group.includes("RX") ? "TX" : "";
  if (!components || !components.length) {
    return components;
  }
  let _components = components ? JSON.parse(JSON.stringify(components)) : [];
  const compIndex = _components.findIndex(item => item.name === component);
  if (compIndex < 0 || !components[compIndex] || !Array.isArray(components[compIndex].pins)) {
    return components;
  }
  let model = _components[compIndex].model, libType = "", libraryId = "", fileName = "";
  if (model && model.files && model.files[0]) {
    libType = model.files[0].type;
    libraryId = model.files[0].libraryId;
    fileName = model.files[0].fileName;
  }

  let modelObj = {};
  if (usage === "Driver") {
    _usage = "Receiver"
  } else if (usage === "Receiver") {
    _usage = "Driver"
  }

  for (let pinItem of _components[compIndex].pins) {
    if (pinItem.group.includes(groupType) && groupType) {
      pinItem.usage = _usage;
      if (!pinItem.model) {
        pinItem.model = {
          libType,
          libraryId,
          fileName,
          modelType: "",
          modelName: "",
          enableVoltage: ""

        }
      }
      // Delete model or not, stimulus
      const prevModelType = pinItem.model.modelType
      const newUsage = pinItem.usage
      const shouldClear = (prevModelType && ONLY_DRIVER_MODEL_TYPES.includes(prevModelType) && newUsage === 'Receiver')
        || (prevModelType && INPUT.includes(prevModelType) && newUsage === 'Driver')

      if (pinItem.model && pinItem.model.libraryId && shouldClear) {
        pinItem.model = {
          ...pinItem.model,
          modelName: "",
          modelType: "",
          enableVoltage: ""
        }
      }

      if (pinItem.usage === "Receiver") {
        pinItem.pinModels = []
      }

      if (pinItem.usage === "Driver" && (!pinItem.pinModels || !pinItem.pinModels.length)) {
        let deviceVcc = ""

        if (pinItem.model.libType === "IBIS" && pinItem.model.libraryId) {
          const id = pinItem.model.libraryId;
          modelObj[id] = modelObj[id] ? modelObj[id] : await getIbisModelList({ libraryId: id, usage: '' })
          const models = modelObj[id];
          const modelInfo = models ? (models.models || []).find(item => item.name === pinItem.model.modelName) : null;
          deviceVcc = modelInfo && modelInfo.deviceVcc && modelInfo.deviceVcc !== "NA" ? parseFloat(modelInfo.deviceVcc).toString() : "";
          _components[compIndex].deviceVcc = deviceVcc || "";
        }

        pinItem.pinModels = updateICPinModelsByBuffer({
          pinModels: pinItem.pinModels,
          usage: pinItem.usage,
          libType: pinItem.model.libType,
          modelType: pinItem.model.modelType || "I/O",
          pu: deviceVcc,
          pd: "0"
        })
      }

      pinItem.powerOff = "";
      signals.push(pinItem.signal);
      compList.push(`${pcbId}::${component}`)
    }
  };

  return _components
}


export {
  updateAllComponentPinsUsage,
  updateICPinModelsByBuffer,
  setDefaultUsageByDriver,
  getPins,
  updateComponentUsageToPinsUsage,
  updateComponentPinsUsageByGroup,
  updateComponentPinsUsageOpposite
}